import React from 'react';
import { Grid, Card, Box, Skeleton, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import styles from './styles';

const EirTacticalCard = ({ card, loading = false }) => {
  const theme = useTheme();
  const renderContent = content => ({ __html: content });

  return (
    <Grid item container xs={12} sm={6}>
      <Card
        sx={{
          ...styles(theme).tactical_cards,
        }}
      >
        <Stack sx={{ textAlign: 'left' }} direction='row'>
          {loading ? (
            <>
              <Skeleton variant='rectangular' sx={{ height: { xs: 90 }, width: 100 }} />
              <Stack direction='column' sx={styles(theme).tacticalCard_SkeletonContent}>
                <Skeleton height={24} width='90%' />
                <Skeleton height={16} width='80%' />
              </Stack>
            </>
          ) : (
            <Grid item container xs={12}>
              <Grid item xs={3}>
                <Box
                  display={{ xs: 'block', md: 'none' }}
                  component='img'
                  alt={card?.mobileImage?.imageAtlText}
                  src={card?.mobileImage?.imageURL}
                  sx={{ width: '100%', height: '100%' }}
                />
                <Box
                  display={{ xs: 'none', md: 'block' }}
                  component='img'
                  alt={card?.desktopImage?.imageAtlText}
                  src={card?.desktopImage?.imageURL}
                  sx={{ width: '100%', height: '100%' }}
                />
              </Grid>
              <Grid
                item
                xs={9}
                sx={[
                  {
                    flex: 1,
                  },
                  styles(theme).tacticalCard_content,
                ]}
              >
                <Typography variant='subtitle1' sx={styles(theme).tacticalCard_Heading}>
                  {card.heading}
                </Typography>
                <Typography
                  variant='body1'
                  sx={styles(theme).tacticalCard_Body}
                  dangerouslySetInnerHTML={renderContent(card.copy)}
                />
              </Grid>
            </Grid>
          )}
        </Stack>
      </Card>
    </Grid>
  );
};

export default EirTacticalCard;
